import { render, staticRenderFns } from "./authorized-user-for-demo-request.html?vue&type=template&id=32f7989e&scoped=true&external"
import script from "./authorized-user-for-demo-request.js?vue&type=script&lang=js&external"
export * from "./authorized-user-for-demo-request.js?vue&type=script&lang=js&external"
import style0 from "./authorized-user-for-demo-request.scss?vue&type=style&index=0&id=32f7989e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7989e",
  null
  
)

export default component.exports